package com.tixforgigs.common.core.models.ui

import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.menu.MaterialMenuDsl
import io.kvision.material.menu.MdMenuItem

@OptIn(ExperimentalMaterialApi::class)
data class MenuItem(
  val text: String,
  val leadingIcon: String? = null,
  val trailingIcon: String? = null,
  val subMenu: List<MenuItem>? = null,
  val classNames: List<String>? = null,
  val config: @MaterialMenuDsl (MdMenuItem.() -> Unit)? = null,
  val onClick: (() -> Unit)? = null
)
